import { MySettingsStore } from './MySettingsStore';
import { refreshRecentOrderIds, loadOrders } from './RecentOrdersStore';
import { ref } from 'vue';
import { pusherClient } from '../pusherClient';

export const storeNotifierChannels = ref<{ [key: string]: ReturnType<typeof pusherClient['subscribe']> }>({});
export const subscribeToStoreNotifier = (storeId: string) => {
    if (storeNotifierChannels.value[storeId]) return;
    storeNotifierChannels.value[storeId] = pusherClient.subscribe(`private-store.${storeId}`);
    // TODO: handle connection errors
    storeNotifierChannels.value[storeId]
        .bind('order-updated', function (data: any) {
            if (data.storeOrderId && data.storeId) {
                loadOrders(data.storeId, [data.storeOrderId]);
            }
        });
}

export const unsubscribeFromStoreNotifier = (storeId: string) => {
    if (storeNotifierChannels.value[storeId]) {
        storeNotifierChannels.value[storeId].unbind_all();
        storeNotifierChannels.value[storeId].unsubscribe();
        delete storeNotifierChannels.value[storeId];
    }
}

export const listenStoreNotifier = (storeId: string) => {
    // Don't create duplicate connections

    if (!MySettingsStore.value[storeId]?.isEnabled) return;
    refreshRecentOrderIds(storeId);
    subscribeToStoreNotifier(storeId);

}

export const disconnectStore = (storeId: string) => {
    unsubscribeFromStoreNotifier(storeId);
}